import React from 'react';
import { motion } from 'framer-motion';
import { Frown, FileSearch, Activity, Calendar, ChefHat, Brain, Clock, Battery } from 'lucide-react';
export function PainPoints() {
  const points = [{
    icon: Frown,
    title: 'No sabés qué cocinar',
    desc: 'Terminás repitiendo siempre las mismas comidas.'
  }, {
    icon: FileSearch,
    title: 'Vivís leyendo etiquetas',
    desc: 'Y aun así tenés miedo de equivocarte.'
  }, {
    icon: Activity,
    title: 'Sentís inflamación constante',
    desc: 'Aunque intentás cuidarte.'
  }, {
    icon: Calendar,
    title: 'No organizás tus comidas',
    desc: 'Y terminás comiendo cualquier cosa.'
  }, {
    icon: ChefHat,
    title: 'Te cuesta encontrar recetas fáciles',
    desc: 'Todo parece complicado o caro.'
  }, {
    icon: Brain,
    title: 'Tenés ansiedad con la comida',
    desc: 'Porque no sabés qué alimentos son realmente seguros.'
  }, {
    icon: Clock,
    title: 'Comés fuera de horario',
    desc: 'Y eso empeora tu bienestar físico.'
  }, {
    icon: Battery,
    title: 'Sentís cansancio o molestias digestivas',
    desc: 'Porque la alimentación no está bien organizada.'
  }];
  return <section className="py-20 px-4" data-id="element-107">
      <div className="max-w-5xl mx-auto" data-id="element-108">
        <div className="text-center mb-16" data-id="element-109">
          <h2 className="font-serif text-4xl md:text-5xl text-forest mb-4" data-id="element-110">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-xl text-muted" data-id="element-111">
            Si sos celíaco/a, seguramente esto te resulte familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-112">
          {points.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05,
          duration: 0.5
        }} className="bg-warm-white p-6 rounded-2xl shadow-warm border border-terracotta/10" data-id="element-113">
              <div className="w-12 h-12 rounded-full bg-terracotta/10 flex items-center justify-center mb-4" data-id="element-114">
                <point.icon className="w-6 h-6 text-terracotta" data-id="element-115" />
              </div>
              <h3 className="font-bold text-forest mb-2" data-id="element-116">{point.title}</h3>
              <p className="text-muted text-sm leading-relaxed" data-id="element-117">{point.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-118">
          <h3 className="font-serif text-2xl md:text-3xl text-terracotta font-medium" data-id="element-119">
            ¿Cuánto tiempo más vas a seguir improvisando tu alimentación?
          </h3>
        </motion.div>
      </div>
    </section>;
}